/* Search dropdown + Cart drawer cua MCU.
   Dung API san co cua Shopify: /search/suggest.json va /cart.js, /cart/change.js.
   Khong phu thuoc JS cua Elessi nen chay giong nhau tren moi trang. */
(function () {
  'use strict';

  var root = document.querySelector('[data-mcu-ov]');
  if (!root) return;

  var CURRENCY = root.getAttribute('data-currency') || 'USD';
  var SEARCH_URL = root.getAttribute('data-routes-search') || '/search';
  var fmt;
  try {
    fmt = new Intl.NumberFormat(undefined, { style: 'currency', currency: CURRENCY });
  } catch (e) {
    fmt = { format: function (n) { return '$' + n.toFixed(2); } };
  }
  var money = function (cents) { return fmt.format((cents || 0) / 100); };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var sized = function (url, w) {
    if (!url) return '';
    var u = url.indexOf('//') === 0 ? 'https:' + url : url;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  };

  // ─────────────────────────── Search ───────────────────────────
  var sPanel = root.querySelector('[data-mcu-search-panel]');
  var sInput = root.querySelector('[data-mcu-search-input]');
  var sResults = root.querySelector('[data-mcu-search-results]');
  var sClose = root.querySelector('[data-mcu-search-close]');

  // Panel tha ngay duoi header — do chieu cao header that thay vi doan
  function placePanel() {
    var h = document.querySelector('.site-header');
    var bottom = h ? Math.ceil(h.getBoundingClientRect().bottom) : 72;
    root.style.setProperty('--mcu-ov-top', Math.max(0, bottom) + 'px');
  }

  function openSearch() {
    placePanel();
    sPanel.hidden = false;
    setTimeout(function () { sInput.focus(); }, 30);
  }
  function closeSearch() {
    sPanel.hidden = true;
    sResults.innerHTML = '';
  }

  var seq = 0;
  var timer = null;

  function renderHits(data, q) {
    var items = (data && data.resources && data.resources.results && data.resources.results.products) || [];
    if (!items.length) {
      sResults.innerHTML = '<p class="mcu-ov__msg">No products match &ldquo;' + esc(q) + '&rdquo;.</p>';
      return;
    }
    var html = items.map(function (p) {
      var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
      return (
        '<a class="mcu-ov__hit" href="' + esc(p.url) + '">' +
        (img ? '<img class="mcu-ov__hit-img" src="' + esc(sized(img, 120)) + '" alt="" loading="lazy">'
             : '<span class="mcu-ov__hit-img"></span>') +
        '<span><p class="mcu-ov__hit-t">' + esc(p.title) + '</p>' +
        '<p class="mcu-ov__hit-p">' + esc(p.price ? money(parsePrice(p.price)) : '') + '</p></span></a>'
      );
    }).join('');
    html += '<a class="mcu-ov__all" href="' + esc(SEARCH_URL) + '?q=' + encodeURIComponent(q) + '">See all results →</a>';
    sResults.innerHTML = html;
  }

  // predictive search tra price dang chuoi ("$19.90") hoac so (cents) tuy phien ban
  function parsePrice(p) {
    if (typeof p === 'number') return p;
    var n = String(p).replace(/[^0-9.]/g, '');
    return Math.round(parseFloat(n || '0') * 100);
  }

  function runSearch(q) {
    var mine = ++seq;
    var url = SEARCH_URL + '/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) { if (mine === seq) renderHits(d, q); })
      .catch(function () {
        if (mine === seq) sResults.innerHTML = '<p class="mcu-ov__msg">Search is unavailable right now.</p>';
      });
  }

  if (sInput) {
    sInput.addEventListener('input', function () {
      var q = sInput.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { seq++; sResults.innerHTML = ''; return; }
      timer = setTimeout(function () { runSearch(q); }, 220);
    });
  }
  if (sClose) sClose.addEventListener('click', closeSearch);

  // ─────────────────────────── Cart drawer ───────────────────────────
  var backdrop = root.querySelector('[data-mcu-cart-backdrop]');
  var drawer = root.querySelector('[data-mcu-cart-drawer]');
  var body = root.querySelector('[data-mcu-cart-body]');
  var foot = root.querySelector('[data-mcu-cart-foot]');
  var countEl = root.querySelector('[data-mcu-cart-count]');
  var subtotalEl = root.querySelector('[data-mcu-cart-subtotal]');
  var cClose = root.querySelector('[data-mcu-cart-close]');

  function setBadge(n) {
    document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = n; });
    document.querySelectorAll('.cart-button').forEach(function (el) {
      el.setAttribute('aria-label', 'Shopping cart, ' + n + ' items');
    });
    if (countEl) countEl.textContent = n;
  }

  function renderCart(cart) {
    setBadge(cart.item_count);
    if (!cart.items || !cart.items.length) {
      body.innerHTML =
        '<div class="mcu-ov__empty"><p>Your cart is empty.</p>' +
        '<a class="mcu-ov__btn mcu-ov__btn--primary" href="/collections/all">Start shopping</a></div>';
      foot.hidden = true;
      return;
    }
    body.innerHTML = cart.items.map(function (it, i) {
      var opts = (it.options_with_values || [])
        .map(function (o) { return esc(o.name) + ': ' + esc(o.value); }).join(' · ');
      return (
        '<div class="mcu-ov__line" data-line="' + (i + 1) + '">' +
        (it.image ? '<img class="mcu-ov__line-img" src="' + esc(sized(it.image, 160)) + '" alt="" loading="lazy">'
                  : '<span class="mcu-ov__line-img"></span>') +
        '<div><p class="mcu-ov__line-t">' + esc(it.product_title) + '</p>' +
        (opts ? '<p class="mcu-ov__line-v">' + opts + '</p>' : '') +
        '<span class="mcu-ov__qty">' +
        '<button type="button" data-q="-1" aria-label="Decrease quantity">−</button>' +
        '<span>' + it.quantity + '</span>' +
        '<button type="button" data-q="1" aria-label="Increase quantity">+</button>' +
        '</span></div>' +
        '<div class="mcu-ov__line-right"><p class="mcu-ov__line-price">' + money(it.line_price) + '</p>' +
        '<button type="button" class="mcu-ov__rm" data-rm>Remove</button></div>' +
        '</div>'
      );
    }).join('');
    subtotalEl.textContent = money(cart.total_price);
    foot.hidden = false;
  }

  function loadCart() {
    body.innerHTML = '<p class="mcu-ov__loading">Loading…</p>';
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {
        body.innerHTML = '<p class="mcu-ov__msg">Could not load your cart. <a href="/cart">Open cart page</a></p>';
      });
  }

  function changeLine(line, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty }),
    })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () { loadCart(); });
  }

  function openCart() {
    backdrop.hidden = false;
    drawer.hidden = false;
    document.body.classList.add('mcu-ov-locked');
    loadCart();
    setTimeout(function () { cClose && cClose.focus(); }, 30);
  }
  function closeCart() {
    backdrop.hidden = true;
    drawer.hidden = true;
    document.body.classList.remove('mcu-ov-locked');
  }

  if (backdrop) backdrop.addEventListener('click', closeCart);
  if (cClose) cClose.addEventListener('click', closeCart);

  if (body) {
    body.addEventListener('click', function (e) {
      var wrap = e.target.closest('[data-line]');
      if (!wrap) return;
      var line = Number(wrap.getAttribute('data-line'));
      if (e.target.closest('[data-rm]')) { changeLine(line, 0); return; }
      var q = e.target.closest('[data-q]');
      if (!q) return;
      var cur = Number(wrap.querySelector('.mcu-ov__qty span').textContent) || 1;
      changeLine(line, Math.max(0, cur + Number(q.getAttribute('data-q'))));
    });
  }

  // ────────── Mo drawer khi co san pham duoc them vao gio ──────────
  // Theme Elessi tu goi fetch('/cart/add.js') tren trang san pham. Ta chi QUAN SAT,
  // KHONG chan submit — neu chan roi tu POST thi se cong don voi handler cua Elessi
  // va them san pham hai lan.
  var ADD_RE = /\/cart\/add(\.js)?(\?|$)/;

  (function watchCartAdds() {
    var origFetch = window.fetch;
    if (typeof origFetch === 'function') {
      window.fetch = function (input) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var p = origFetch.apply(this, arguments);
        if (ADD_RE.test(url) && p && p.then) {
          p.then(function (res) {
            if (res && res.ok) setTimeout(openCart, 80);
          }).catch(function () {});
        }
        return p;
      };
    }

    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__mcuIsAdd = ADD_RE.test(String(url || ''));
      return origOpen.apply(this, arguments);
    };
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      if (this.__mcuIsAdd) {
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) setTimeout(openCart, 80);
        });
      }
      return origSend.apply(this, arguments);
    };
  })();

  // ─────────────────────────── Noi vao header ───────────────────────────
  document.addEventListener('click', function (e) {
    var s = e.target.closest('.search-button, [data-mcu-search-open]');
    if (s) { e.preventDefault(); sPanel.hidden ? openSearch() : closeSearch(); return; }
    var c = e.target.closest('.cart-button, [data-mcu-cart-open]');
    if (c) { e.preventDefault(); openCart(); return; }
    // bam ra ngoai thi dong search
    if (!sPanel.hidden && !e.target.closest('[data-mcu-search-panel]')) closeSearch();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (!drawer.hidden) closeCart();
    else if (!sPanel.hidden) closeSearch();
  });

  window.addEventListener('resize', function () { if (!sPanel.hidden) placePanel(); }, { passive: true });

  // Dong bo so tren badge khi tai trang
  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (c) { setBadge(c.item_count); })
    .catch(function () {});
})();
